import React, { useEffect, useState } from "react";
import { getApi } from "../../../../services/api/globalApi";
import CustomBarChart from "./BarChart";
import CustomLineChartChart from "./LineChart";
import Title from "../../../../components/common/title/Title";

const SalesLineChart = () => {
  const [data, setData] = useState([])
  const getData = async () => {
    try {
      const res = await getApi({ path: "admin/reports/getOrderSalesPriceReportMonthly" })
      setData(res.data?.result)
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    getData()
  }, []);

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6 mt-6 mb-6">
      <Title title={"فروش سه ماه اخیر"} />
      <div className="w-full flex flex-col sm:flex-row items-center sm:items-start flex-wrap my-8 gap-6 px-6">
        <div className="flex-1 w-full sm:w-1/2">
          <CustomLineChartChart
            Linedatakey="foroshKhales"
            XAxisDataKey="month"
            name="فروش خالص"
            data={data}
          />
        </div>
        <div className="flex-1 w-full sm:w-1/2">
          <CustomBarChart
            barkey="count"
            xAxisField="month"
            name="تعداد سفارش"
            data={data}
          />
        </div>
      </div>
    </div>

  );
};

export default SalesLineChart;
